<template>
  <div class="org">
    <div class="org-tree">
      <div class="group_tree">
        <el-input placeholder="请输入部门" v-model.trim="treeSearchParam" prefix-icon="el-icon-search" maxlength="100" size="small">
          <template slot="append">
            <el-button type="primary" @click="handleIconClick">搜索</el-button>
          </template>
        </el-input>
        <div class="tree-only">
          <base-tree
            highlightCurrent
            ref="tree"
            class="flex-1"
            :data="data"
            node-key="id"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :default-expanded-keys="defaultNode"
            @node-click="handleNodeClick"
          >
          </base-tree>
        </div>
      </div>
    </div>
    <div class="org-list">
      <div style="display: flex">
        <div style="display: flex; margin-bottom: 15px; flex: 1">
          <el-input placeholder="请输入员工姓名" style="margin-left: 10px; width: 55%" v-model.trim="searchname" prefix-icon="el-icon-search" maxlength="100" size="small">
            <template slot="append" props>
              <el-button type="primary" @click="search">搜索</el-button>
            </template>
          </el-input>
        </div>
      </div>
      <Table
        :highlight-current-row="isMultiple ? false : true"
        :isSelect="isMultiple ? true : false"
        class="ml-10"
        :data="tableData"
        :columns="columns"
        ref="table"
        :pages="pages"
        @select="select"
        @select-all="select"
        :noCheck="noCheck"
        @current-change="handleCurrentChange"
        @selectionChange="selectionChange"
        @currentChange="pageChange"
      >
        <template #operate="{ row }" v-if="!isMultiple">
          <div class="operator">
            <div style="color: #355aff; cursor: pointer" @click="selectUser(row)">选择</div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import Table from "@/components/Table";
import BaseTree from "@/components/base-tree.vue";
import OrgApi from "@/apis/org";

export default {
  props: {
    isMultiple: {
      default: () => true,
    },
    selectUsers: {
      default: () => [],
    },
    selectRoleNode: {
      default: () => [],
    },
    noCheck: {
      default: () => 0,
    },
  },
  data() {
    return {
      defaultProps: {
        children: "childs",
        label: "name",
      },
      searchname: "",
      tableData: [],
      columns: [
        { label: "员工姓名", prop: "realName" },
        { label: "所属部门", prop: "departmentName" },
      ],
      pages: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
      },
      formLabelWidth: "150px",
      // compId: this.$store.state.comp.compId,
      departmentId: 0, //部门ID
      selectNode: "",
      selectedRow: [],
      treeSearchParam: "",
      data: [
        {
          id: 0,
          name: "总公司",
          childs: [],
        },
      ],
      defaultNode: [],
    };
  },
  mounted() {
    this.getTree();
    this.getUsersList();
    if (this.noCheck) {
      this.$emit("selectChange", this.selectUsers);
    }
  },
  methods: {
    selectChange(e) {
      this.selectedRow = e;
    },
    handleIconClick(ev) {
      this.$refs.tree.returnRef().filter(this.treeSearchParam);
    },
    async getTree() {
      const res = await OrgApi.getAllDepartmentTree();
      this.data[0].childs = res;
      this.defaultNode.push(this.data[0].id);
      this.$refs.tree.returnRef().setCurrentKey(this.data[0].id);
    },
    handleFilter() {
      this.$refs.tree.returnRef().filter(this.treeSearchParam.trim());
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //树点击事件
    handleNodeClick(data) {
      this.selectNode = data;
      this.departmentId = data.id;
      this.pages.currentPage = 1;
      this.getUsersList();
    },
    //获取用户列表
    getUsersList() {
      let url = `/Crm/User/UserList?deptId=${this.departmentId ? this.departmentId : -1}&keyWords=${this.searchname}&page=${this.pages.currentPage}&pageSize=${this.pages.pageSize}`;
      this.$axios.get(url).then((res) => {
        if (res.data.length) {
          res.data.forEach((d) => {
            d.departmentName = d.departmentList && d.departmentList.map((_d) => _d.departmentName).join(",") || '总公司';
          });
        }
        this.tableData = res.data;
        this.$nextTick(() => {
          if (this.isMultiple) {
            this.$refs.table.getTable().clearSelection();
            if (this.selectRoleNode.roleName == "管理员") {
              this.selectUsers.forEach((s) => {
                this.tableData.forEach((c) => {
                  if ((s.id || s.userId) === c.id) {
                    this.$refs.table.getTable().toggleRowSelection(c, true);
                  }
                  if (c.isCompCreate == 1) {
                    c.typeName = "delivery";
                    c.deliveryType = c.isCompCreate;
                  }
                });
              });
            } else {
              this.selectUsers.forEach((s) => {
                this.tableData.forEach((c) => {
                  if ((s.id || s.userId) === c.id) {
                    this.$refs.table.getTable().toggleRowSelection(c, true);
                  }
                });
              });
            }
          }
        });
        this.pages.total = res.dataCount;
      });
    },
    //用户查询
    search() {
      this.pages.currentPage = 1;
      this.getUsersList();
    },
    //点击翻页
    pageChange(p) {
      this.pages.currentPage = p;
      this.getUsersList();
    },
    handleCurrentChange(val) {
      if (this.isMultiple) {
        return;
      }
      this.selectUsers.length = 0;
      this.selectUsers.push(val);
    },
    select(data, row) {
      if (!this.isMultiple) {
        return;
      }
      if (row === undefined) {
        if (data.length) {
          if (data.length == 1 && data[0]["isCompCreate"] == 1) {
            this.tableData.forEach((t) => {
              let ind = this.selectUsers.findIndex((s) => {
                return s.id === t.id;
              });
              if (ind > -1) {
                this.selectUsers.splice(ind, 1);
              }
            });
            this.selectUsers.push(data[0]);
          } else {
            data.forEach((d) => {
              let has = this.selectUsers.some((s) => s.id === d.id);
              if (!has) {
                this.selectUsers.push(d);
              }
            });
          }
        } else {
          this.tableData.forEach((t) => {
            let ind = this.selectUsers.findIndex((s) => {
              return s.id === t.id;
            });
            if (ind > -1) {
              this.selectUsers.splice(ind, 1);
            }
          });
          if (data.length == 1) {
            this.selectUsers.push(data[0]);
          }
        }
      } else {
        if (data.length) {
          let has = data.some((d) => d.id === row.id);
          if (has) {
            let hass = this.selectUsers.some((s) => s.id === row.id);
            if (!hass) {
              this.selectUsers.push(row);
            }
          } else {
            let ind = this.selectUsers.findIndex((s) => s.id === row.id);
            if (ind > -1) {
              this.selectUsers.splice(ind, 1);
            }
          }
        } else {
          let index = this.selectUsers.findIndex((s) => {
            return s.id === row.id;
          });
          if (index > -1) {
            this.selectUsers.splice(index, 1);
          }
        }
      }
      this.$emit("selectChange", this.selectUsers);
    },
    selectionChange(data) {
      this.$emit("selectionChange", this.selectUsers);
    },
    selectUser(row) {
      this.$emit("selectionChange", row);
    },
  },
  components: { Table, BaseTree },
};
</script>

<style lang="scss" scoped>

.org {
  display: flex;
  height: 500px;

  .org-tree {
    width: 32%;
    display: flex;
    flex-direction: column;
  }

  .org-list {
    flex: 1;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}
.group_tree {
  font-size: 13px;
  line-height: 2;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;

  .tree-only {
    border: 1px solid #d7d7d7;
    flex: 1;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: white;
  }

  /deep/ .el-tree-node__content {
    height: 26px;
  }

  .el-tree-node {
    display: flex;
    flex: 1;

    span:first-child {
      flex: 1;
    }

    .tree_operate {
      display: none;
    }

    &:hover {
      .tree_operate {
        display: block;
      }
    }
  }

  /deep/ .el-tree {
    overflow: auto;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0;
  }
}
</style>
